import { g as t, H as $, C as T, _ as u } from "./export-cdcbfb2b.js";
import { f as d } from "./function-apply-4756dee6.js";
import { e as h } from "./environment-ddee5959.js";
import { a as I } from "./array-slice-79f93c56.js";
import { v as A } from "./validate-arguments-length-eb516e5b.js";
var m = t, x = d, E = T, F = h, N = $, y = I, S = A, _ = m.Function, C = /MSIE .\./.test(N) || F === "BUN" && function() {
  var r = m.Bun.version.split(".");
  return r.length < 3 || r[0] === "0" && (r[1] < 3 || r[1] === "3" && r[2] === "0");
}(), g = function(r, e) {
  var n = e ? 2 : 1;
  return C ? function(a, b) {
    var s = S(arguments.length, 1) > n, i = E(a) ? a : _(a), p = s ? y(arguments, n) : [], o = s ? function() {
      x(i, this, p);
    } : i;
    return e ? r(o, b) : r(o);
  } : r;
}, R = u, f = t, U = g, v = U(f.setInterval, !0);
R({ global: !0, bind: !0, forced: f.setInterval !== v }, {
  setInterval: v
});
var B = u, c = t, L = g, l = L(c.setTimeout, !0);
B({ global: !0, bind: !0, forced: c.setTimeout !== l }, {
  setTimeout: l
});
